import { Component, OnInit, ViewChild } from "@angular/core";
import { PopOverComponent } from "../../pop-over/pop-over.component";
import { MarkerInOut } from "../../../domain/marker-in-out";

@Component({
  selector: "evrideo-dtmf-popover",
  templateUrl: "./dtmf-popover.component.html",
  styleUrls: ["./dtmf-popover.component.scss"],
})
export class DtmfPopoverComponent implements OnInit {
  @ViewChild("popup", { static: true }) popup: PopOverComponent;

  inOutOptions = [
    { label: "IN", value: MarkerInOut.In },
    { label: "OUT", value: MarkerInOut.Out },
  ];

  selectedInOut;
  selectedRange;

  constructor() {}

  ngOnInit(): void {}

  showPopup(e: MouseEvent): void {
    this.popup.toggle(e);
  }

  onInoutChange({ value }) {
    this.selectedInOut = value;
  }

  onRangeChange(range: number) {
    this.selectedRange = range;
  }
}
